import {
  styled,
  rem
} from 'config/stitches.config'

import Container from '@/UI/Container'
import { StyledSectionContent } from '@/Section/Container/styles'

export const StyledStandardModal = styled('div', {
  display: 'block',
  position: 'fixed',
  top: 0,
  left: 0,
  zIndex: 10,
  height: '100%',
  width: '100%',
  opacity: 0
})

export const StyledStandardModalContainer = styled('div', {})

export const StyledStandardModalClose = styled('button', {})

export const StyledMenuModalContainer = styled(StyledSectionContent, {
  height: '100%',
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'flex-end',
  paddingTop: rem(128),
  paddingBottom: rem(64),
  alignItems: 'flex-start'
})

export const StyledSearchModalContainer = styled(Container, {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  paddingY: 0,
  height: '100%',
})


export const StyledFormModalContainer = styled(Container, {
  display: 'flex',
  alignItems: 'flex-start',
  justifyContent: 'space-between',
  columnGap: '$4',
  color: '$white',
  paddingY: rem(44),

  '.SuccessMessage, button': { flexShrink: 0 }
})
